import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSpeedtestComponent } from './simple-icons-speedtest.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSpeedtestComponent ],
    exports:      [ SimpleIconsSpeedtestComponent ],
    bootstrap:    []
})
export class SimpleIconsSpeedtestModule {}
